export default "__VITE_ASSET__d_ZkrOCx__"